/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new company.
 * @export
 * @interface CreateCompanyRequest
 */
export interface CreateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    phone?: string;
    /**
     * Optional claim invite token from an invitation link. When present, the new owner is granted access to the invited claim regardless of the email they signed up with.
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    claimInviteToken?: string;
}

/**
 * Check if a given object implements the CreateCompanyRequest interface.
 */
export function instanceOfCreateCompanyRequest(value: object): value is CreateCompanyRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCompanyRequestFromJSON(json: any): CreateCompanyRequest {
    return CreateCompanyRequestFromJSONTyped(json, false);
}

export function CreateCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'claimInviteToken': json['claimInviteToken'] == null ? undefined : json['claimInviteToken'],
    };
}

export function CreateCompanyRequestToJSON(json: any): CreateCompanyRequest {
    return CreateCompanyRequestToJSONTyped(json, false);
}

export function CreateCompanyRequestToJSONTyped(value?: CreateCompanyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'domain': value['domain'],
        'address': value['address'],
        'phone': value['phone'],
        'claimInviteToken': value['claimInviteToken'],
    };
}

